import { useState } from 'react';

const useShareableState = () => {
  const [modulesList, setModulesList] = useState();
  return { modulesList, setModulesList }
}

export default useShareableState